require("./login.style.scss");

class LoginController {
    constructor(
        $state,
        $filter,
        $stateParams,
        config,
        loginService,
        storageService,
        sseService,
        principalService,
        crudService,
        sharedService,
        iamPersistenceService
    ) {
        this.$state = $state;
        this.$filter = $filter;
        this.redirectUrl = config.redirectUrl;
        this.proxyUrl = config.proxyUrl;
        this.loginService = loginService;
        this.storageService = storageService;
        this.sharedService = sharedService;
        this.iamPersistenceService = iamPersistenceService;
        this.sseService = sseService;
        this.principalService = principalService;
        this.crudService = crudService;
        this.loginObj = $stateParams.loginObj;
        this.errorLink = null;
        const protocol = window.location.protocol ? window.location.protocol : 'http:';

        this.msalConfig = {
            identityMetadata: "https://login.microsoftonline.com/common/oauth2/v2.0/",
            clientId: config.clientId,
            redirectUrl: protocol + '//' + window.location.host + '/',
            scope: ["https://management.azure.com/user_impersonation"]
        };
    }

    $onInit() {
        if (angular.isDefined(this.storageService.getToken()) && this.storageService.getToken()) this.$state.go('app.dashboard');
        this.validateOnInit();
        this.handleError = (err) => {
            if (err.data.message) {
                this.message = err.data.message.title;
                this.messageDetails = err.data.message.details;
                if (err.data.message.link) {
                    this.errorLink = err.data.message.link;
                }
            } else {
                this.message = 'An Error Has Occurred';
            }
            this.busy = false;
        };

        if (this.loginObj) {
            this.login();
        }

    }

    login() {
        this.message = undefined;
        this.principalService.outOnTokenExpired = undefined;

        if (this.loginObj.code || this.loginObj.id_token) {
            this.busy = true;
            let code = this.loginObj.code;
            this.crudService
                .get(this.proxyUrl + `api/v1/auth/login?code=${code}`, null, null, null, null, true, true)
                .then((res) => {
                    if (res.data.entities[0].tenantDtoList) {
                        this.openTenantDialog(res);
                    } else {
                        this.onTokenLogin(res);
                    }
                }, this.handleError);
        }
    }

    loginRequest() {
        const loginUrl = `${this.msalConfig.identityMetadata}/authorize?client_id=${this.msalConfig.clientId
            }&response_type=code&response_mode=query&scope=${this.msalConfig.scope[0]}&redirect_uri=${this.msalConfig.redirectUrl
            }`;

        window.location.href = loginUrl;
    }

    openTenantDialog(res) {
        this.tenantList = res.data.entities[0].tenantDtoList;
        this.userUuid = res.data.entities[0].userUuid;
        this.showTenantDialog = true;
        this.busy = false;
    }


    tenantLogin(tenantUuid) {
        this.showTenantDialog = false;
        this.busy = true;
        this.crudService.get(this.proxyUrl + `api/v1/auth/login/${tenantUuid.value}?&userUuid=${this.userUuid}`, null, null, null, null, true, true).then((res) => {
            this.onTokenLogin(res);
        });
    }

    onTokenLogin(res) {
        const accessToken = res.data.entities[0].token.accessToken;
        this.storageService.setToken(res.data.entities[0].token);
        this.crudService.get(this.proxyUrl + `api/v1/auth/redirect`, null, null, null, null, true, true, true, accessToken).then((res) => {
            this.storageService.setManagerHostname(res.data.entities[0].managerHostname);
            this.storageService.setTempsubscriptionId(res.data.entities[0].subscription);
            this.loginService.login(res.data.entities[0].user.email, res.data.entities[0].managerHostname, res.data.entities[0].subscription);
            this.storageService.setSubscription(res.data.entities[0].subscription);
            this.iamPersistenceService.getPermissions(res.data.entities[0].managerHostname, res.data.entities[0].subscription.uuid).then((resP) => {
                this.storageService.setPermissions(resP);
                if (res.data.entities[0].protectionSet.uuid) {
                    this.storageService.setProtectionSet(res.data.entities[0].protectionSet);
                    window.location.href = '/#!/app/dashboard';

                } else {
                    this.sharedService.getProtectionSets().then(res => {
                        const defaultProtectionSet = res.find((protectionSet => protectionSet.name === "default"));
                        this.storageService.setProtectionSet(defaultProtectionSet);
                        window.location.href = '/#!/app/dashboard';
                    });
                }
            });
        }, this.handleError);
    }

    validateOnInit() {
        this.unreachableMessage = this.principalService.outOnUnreachable;

        this.expiredMessage = this.principalService.outOnTokenExpired;
        if (!this.unreachableMessage && !this.expiredMessage) return;
        this.message = this.expiredMessage
            ? this.$filter("translate")("login.form.signin.info.expired")
            : "";
    }

    fadeInWrapper() {
        $('.login-wrapper').fadeIn(0);
    }
}

LoginController.$inject = [
    "$state",
    "$filter",
    "$stateParams",
    'config',
    "loginService",
    "storageService",
    "sseService",
    "principalService",
    "crudService",
    "sharedPersistenceService",
    "iamPersistenceService"
];
const loginComponent = {
    controller: LoginController,
    template: require("./login.template.html")
};

module.exports = loginComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/login/login.component.js